/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getFeaturedMusic} from '../api'

 export const useQueryGetFeaturedMusic = createReactQueryHook('getFeaturedMusic', getFeaturedMusic)
